export default {
  fb: {
    url:           '//connect.facebook.net/{locale}/sdk.js',
    defaultLocale: 'en_US',
  },
  fbdebug: {
    url:           '//connect.facebook.net/{locale}/sdk/debug.js',
    defaultLocale: 'en_US',
  },
  twitter: {
    url:   '//platform.twitter.com/widgets.js',
    event: 'twitter:ready',
  },
  pinterest: {
    url:   '//assets.pinterest.com/js/pinit.js',
    event: 'pinterest:ready',
  },
  vk: {
    url:   '//vk.com/js/api/share.js?90',
    event: 'vk:ready',
  },
  recaptcha: {
    url:    '//www.google.com/recaptcha/api.js?onload=recaptchaOnload&render=explicit',
    cbName: 'recaptchaOnload',
    cb:     function() {
      NGX.App.Events.trigger('recaptcha:ready');
    },
  },
  turnstile: {
    url:    '//challenges.cloudflare.com/turnstile/v0/api.js?onload=turnstileOnload&render=explicit',
    cbName: 'turnstileOnload',
    cb:     function() {
      NGX.App.Events.trigger('turnstile:ready');
    },
  },
};
